import { defineComponent as n, useCssVars as i, computed as o, createElementBlock as a, openBlock as d, normalizeStyle as c, normalizeClass as h, createElementVNode as m, unref as u } from "vue";
import p from "../../node_modules/@alegradev/smile-icons/dist/smile-icons.svg.js";
const f = ["xlink:href"], y = /* @__PURE__ */ n({
  __name: "SmIcon",
  props: {
    icon: { default: "help" },
    size: { default: "medium" },
    type: {},
    hoverColor: {},
    disabled: { type: Boolean },
    width: {},
    height: {},
    color: {},
    fluid: { type: Boolean }
  },
  setup(l) {
    i((e) => ({
      "7a44dd04": e.color,
      e7cedb68: e.hoverColor
    }));
    const s = l, r = o(() => {
      const e = new Blob([p], { type: "image/svg+xml;charset=utf-8" });
      return URL.createObjectURL(e);
    }), t = o(() => `${r.value}#${s.icon}`);
    return (e, b) => (d(), a("svg", {
      class: h(["sm-icon", { disabled: e.disabled, fluid: e.fluid, hoverable: !!e.hoverColor }, e.type, e.size]),
      style: c({ width: e.width, height: e.height })
    }, [
      m("use", { "xlink:href": u(t) }, null, 8, f)
    ], 6));
  }
});
export {
  y as default
};
